/*
 * Filename: d:\projects\AutoFiFront\src\Theme\LinkStyled.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Tuesday, February 14th 2023, 2:19:02 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import styled from "styled-components";

const LinkStyled = styled.a.attrs(props => ({
    bgColor: props.bgColor,
}))`
color: ${props => props.bgColor == "CITYCAR" ? props.theme.colors.second : props.bgColor == "SUV" ? props.theme.colors.third : props.bgColor == "UTILITY" ? props.theme.colors.fourth : props.bgColor == "SEDAN" ? props.theme.colors.fifth : props.bgColor == "BREAK" ? props.theme.colors.sixth : props.theme.colors.first};
&:hover{
    color: ${props => props.bgColor == "CITYCAR" ? props.theme.colors.second : props.bgColor == "SUV" ? props.theme.colors.third : props.bgColor == "UTILITY" ? props.theme.colors.fourth : props.bgColor == "SEDAN" ? props.theme.colors.fifth : props.bgColor == "BREAK" ? props.theme.colors.sixth : props.theme.colors.first};
}
`;

export default LinkStyled;
